import { render, staticRenderFns } from "./ModifyDeliver.vue?vue&type=template&id=4331126e&scoped=true&"
import script from "./ModifyDeliver.vue?vue&type=script&lang=js&"
export * from "./ModifyDeliver.vue?vue&type=script&lang=js&"
import style0 from "./ModifyDeliver.vue?vue&type=style&index=0&id=4331126e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331126e",
  null
  
)

export default component.exports